var map = {
	"./icons/cloud/1-infraestruturas.svg": 356,
	"./icons/cloud/2-aplicacoes.svg": 357,
	"./icons/cloud/3-publica.svg": 358,
	"./icons/cloud/4-privada.svg": 359,
	"./icons/cloud/5-suporte.svg": 360,
	"./icons/homepage/1-icon.svg": 361,
	"./icons/homepage/2-icon.svg": 362,
	"./icons/homepage/3-icon.svg": 363,
	"./icons/homepage/4-icon.svg": 364,
	"./icons/homepage/5-icon.svg": 365,
	"./icons/homepage/6-icon.svg": 366,
	"./icons/icon-rato.svg": 192,
	"./icons/jobs/1_curiosidade.svg": 367,
	"./icons/jobs/2_atitude.svg": 368,
	"./icons/jobs/3_transparencia.svg": 369,
	"./icons/jobs/4_equipa.svg": 370,
	"./icons/play.svg": 138,
	"./icons/ux-ui/1-comunicacao.svg": 371,
	"./icons/ux-ui/2-produtos.svg": 372,
	"./icons/ux-ui/3-aumento.svg": 373,
	"./icons/why-nearshorit/1-talento.svg": 374,
	"./icons/why-nearshorit/2-reducao-custos.svg": 375,
	"./icons/why-nearshorit/3-reducao-risco.svg": 376,
	"./icons/why-nearshorit/4_projetos.svg": 377,
	"./icons/why-nearshorit/5_core.svg": 378,
	"./icons/why-nearshorit/6_eficiencia.svg": 379,
	"./icons/why-nearshorit/7_proximidade.svg": 380,
	"./icons/world.svg": 381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;